import { LINK_TRUST_REVOKED_KEY } from '~/constants/stripeLinkTrust.constants'
import { readLinkTrustRevocationsFromStorage } from '~/utils/readLinkTrustRevocationsFromStorage'
import { useStripeLinkTrustStore } from '~/stores/useStripeLinkTrustStore'

// Mirrors a trust change made in another browsing context into this one's reactive state.
let activeTeardown: (() => void) | undefined

export const installStripeLinkTrustSync = (): (() => void) => {
  if (activeTeardown !== undefined) return activeTeardown
  if (typeof window === 'undefined')
    return () => {
      return undefined
    }

  const store = useStripeLinkTrustStore()
  const handleStorage = (event: StorageEvent): void => {
    if (event.key !== LINK_TRUST_REVOKED_KEY) return
    // Re-reads current storage instead of trusting event.newValue, which can be stale if this
    // tab already wrote a newer value before a delayed event from another tab is processed.
    const next = readLinkTrustRevocationsFromStorage(() => localStorage, LINK_TRUST_REVOKED_KEY)
    store.revocationsByIdentity = next.revocationsByIdentity
    store.universalRevokedAt = next.universalRevokedAt
  }

  window.addEventListener('storage', handleStorage)
  activeTeardown = () => {
    window.removeEventListener('storage', handleStorage)
    activeTeardown = undefined
  }
  return activeTeardown
}
